import { SelectMenuOption } from "../../../form/select-menu/select-menu.component";

export enum FormFieldType {
  Text = 1,
  LongText = 2,
  Select = 3,
  Date = 4,
  Hour = 5,
  Checkbox = 6,
  Number = 7,
  MultiSelect = 8,
}

export interface FormQuestion {
  fieldName: string;
  value: any;
  label: string;
  fieldType: FormFieldType;
  isRequired: boolean;
  order: number;
  maxLength?: number;
  selectItems?: SelectMenuOption[];
  selectedOption?: SelectMenuOption;
  selectedMultipleOptions?: SelectMenuOption[];
  placeHolder?: string;
  customStyle?: "half-row";
  customIcon?: string;
  customAttributes?: Partial<CustomAttributesFormQuestions>;
}
export interface CustomAttributesFormQuestions {
  alwaysDisabled: boolean;
  alwaysHide: boolean;
  hideIfNoValue: boolean;
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/event-page-models/form-question.ts